export class CreateCarUserTokenEntity {
  id;
  carId;
  userId;
  tokenId;
  fob;
  isOccupied;
  isActive;
  car;
  token;
  constructor(
    id = 0,
    carId = null,
    userId = null,
    tokenId = null,
    fob = "",
    isOccupied = false,
    isActive = true,
    car = null,
    token = null
  ) {
    this.id = id;
    this.carId = carId;
    this.userId = userId;
    this.tokenId = tokenId;
    this.fob = fob;
    this.isOccupied = isOccupied;
    this.isActive = isActive;
    this.car = car;
    this.token = token;
  }
}
